<template>
  <div class="header flex w-full bg-[#242929] flex-shrink-0">
    <button
      type="button"
      class="label text-white/40 px-[10px] py-[7px] self-center text-[13px] whitespace-nowrap overflow-hidden overflow-ellipsis select-none"
      :class="{
        'cursor-default text-white/80': isComponent,
        'cursor-pointer': !isComponent,
      }"
      @click="onClickSection"
    >
      Components
    </button>
    <button
      type="button"
      class="label text-white/40 px-[10px] py-[7px] self-center text-[13px] whitespace-nowrap overflow-hidden overflow-ellipsis select-none"
      :class="{
        'cursor-default text-white/80 ': !isComponent,
        'cursor-pointer': isComponent,
      }"
      @click="onClickSection"
    >
      Assets
    </button>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed } from 'vue';

const store = useStore();

const getSidebarSection = computed(
  () => store.getters['application/getSidebarSection']
);

const isComponent = computed(() => {
  return getSidebarSection.value === 'Components';
});

/**
 * Event handler - click on the Components or Assets section button
 */
const onClickSection = event => {
  const label = event.target.innerText;
  store.dispatch('application/setSidebarSection', { value: label });
};
</script>
